import type { SYSTableDef } from "../../../../../../../_ovlclient/src/library/table/tableapi"

export type Offering = {
  DocEntry: number
  DocNum: number
  Comments: string
  DocDate: string
  U_ITF_PRT_FileName: string
  //Del Date
  U_COR_LI_1: string
  DocTotal: number
  U_ITF_PRT_OfferStatus: string
  U_ITF_PRT_OfferError: string
  U_ITF_PRT_OfferEmailInfo: string
  U_ITF_PRT_OfferByAdmin?: string
  U_ITF_PRT_OfferType?: string
  U_ITF_PRT_OfferMainType?: "CAD" | "CUT"
  CntctName?: string
}

export type TblOfferingColumn = keyof Offering

export type TblOffering = {
  [key: string]: Offering
}

export let tblOffering: SYSTableDef = {
  id: "QUTOffering",
  /*title: { dialogTitle: { doNotDisplayId: true } },*/
  feature: "QUTOffering",
  database: {
    dataIdField: "DocEntry",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "offering",
  },
  features: {
    focusToFirstEditableField: false,
    edit: true,
    delete: true,
    filter: true,
  },
  title: { dialogTitle: { translationKey: "QUTOfferingTableDialogTitle" } },
  options: {
    rendering: { controls: { fillSpaceIfNotVisible: false } },
    initial_sort: { field: "DocEntry", direction: "desc" },
    edit: {
      editType: "big",
    },
    customRowActions: {
      GotoDetail: {
        icon: "sap-icon--activities",
        translationKey: "QUTOfferingOfferingGotoDetail",
      },
      Resume: {
        icon: "sap-icon--accidental-leave",
        translationKey: "QUTOfferingOfferingResume",
      },
      EmailNotification: {
        icon: "sap-icon--email",
        translationKey: "QUTOfferingOfferingEmailNotificationOn",
      },
      AdminCutOfferExport: {
        icon: "sap-icon--machine",
        translationKey: "QUTOfferingPosAdminCutOfferExport",
      },
      AdminCutOfferPurchaseExport: {
        icon: "sap-icon--create-form",
        translationKey: "QUTOfferingPosAdminCutOfferPurchaseExport",
      },
    },
  },

  columns: {
    DocEntry: {
      sortable: true,
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingDocNum",
        align: "left",
        visibility: "Table_View",
      },
    },

    CntctName: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingCntctName",
        visibility: "Table_View",
      },
    },

    Comments: {
      ui: { labelTranslationKey: "QUTOfferingColOfferingComments" },
      filter: { rangeFilter: { selected: "none", defaultFilterType: "like" } },
    },

    DocDate: {
      type: "date",
      sortable: true,
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingDocDate",
        visibility: "Table_View",
      },
    },

    U_ITF_PRT_FileName: {
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingFileName",
        visibility: "Table_View",
      },
    },

    U_COR_LI_1: {
      type: "date",
      sortable: true,
      list: {
        displayField: "WeekNr",
        valueField: "MidDate",
        acceptOnlyListValues: true,
        displayValueField: false,
      },
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingDelDate",
        sortByValue: true,
      },
    },
    U_ITF_PRT_OfferByAdmin: {
      type: "text",
      control: "checkbox",
      ui: {
        labelTranslationKey: "QUTOfferingColOfferingByAdmin",
        checkedValue: "Y",
        visibility: "Edit",
      },
    },
    U_ITF_PRT_OfferType: {
      list: {
        displayField: "OfferTypeName",
        valueField: "OfferType",
        mode: "Option",
      },
      ui: {
        option: { inline: true },
        visibility: "Edit",
        labelTranslationKey: "QUTOfferingColOfferingAdminOfferType",
      },
    },

    DocTotal: {
      ui: {
        labelTranslationKey: "QUTOfferingOfferingColTotal",
        visibility: "Table_View",
        align: "right",
      },
    },
  },
}
